document.addEventListener("DOMContentLoaded", function (e) {
  scrollToLinks();
  checkoutLink();
})

const scrollToLinks = function () {
  const scroll_links = document.querySelectorAll("a[href*='#scroll_to']")
  if (scroll_links.length > 0) {
    scroll_links.forEach(function (link) {
      link.addEventListener("click", function scrollEvent(e) {
        const href = e.currentTarget.getAttribute('href')
        const scroll_target = href.split("#scroll_to_").pop()
        const scroll_el = document.querySelector(`[section-name='${scroll_target}']`) || document.querySelector(`.${scroll_target}`) || null
        if (scroll_el) {
          utils.scrollElementToTop(scroll_el);
        }
      })
    })
  }
}

const checkoutLink = function () {
  const checkoutLink = document.querySelector("#checkout")
  if (checkoutLink) {
    checkoutLink.addEventListener("click", function (e) {
      trackEvents.checkout()
    })
  }
}